import styles from "@/asserts/styles/formSection.module.less";
import ModalSectionHeader from "@/components/ui/ModalSectionHeader";
import { EditInquiryFormValues } from "../../type";
import { Form, Row } from "antd";
import { PRATableList } from "./PRATableList";
import { PPMTableList } from "./PPMTableList";
import { NPLMTableList } from "./NPLMTableList";
import { SearchMaterial } from "./SearchMaterial";
import { MaterialSapVo } from "@/apis/sap.api";
import { useTranslation } from "react-i18next";

export function InquiryDetailFields({ disabled }: { disabled: boolean }) {
  const { t } = useTranslation("inquiryManagement");
  const form = Form.useFormInstance<EditInquiryFormValues>();

  const biddingType = Form.useWatch("biddingType", form);

  const MaterialTypeList = {
    PRODUCTION_RAW_AUXILIARY: PRATableList,
    PRODUCTION_PACKAGING_MRO: PPMTableList,
    NON_PRODUCTION_LAB_MRO: NPLMTableList,
  };

  const Component =
    MaterialTypeList[biddingType as keyof typeof MaterialTypeList];

  const handleSelect = (materials?: MaterialSapVo[]) => {
    if (materials && materials.length > 0) {
      let originItemList = form.getFieldValue("itemList") || [];
      originItemList = originItemList.filter(
        (item: any) => item.materialNameCn || item.materialNameEn,
      );

      const selected = materials.map((item) => ({
        materialCode: item.f101,
        materialNameCn: item.f102,
        materialNameEn: item.f103,
        materialType: item.f104,
        quantityUnit: item.f107,
      }));
      form.setFieldValue("itemList", [...originItemList, ...selected]);
    }
  };

  return (
    <div className={styles.formSection}>
      <ModalSectionHeader title={t("询价明细")} />

      <div className={styles.sectionBody}>
        <Row hidden={disabled}>
          <SearchMaterial onSelect={handleSelect} />{" "}
        </Row>
        {Component && <Component disabled={disabled} />}
      </div>
    </div>
  );
}
